import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/service/config.service';

@Component({
  selector: 'app-left-side-menu-admin-control',
  templateUrl: './left-side-menu-admin-control.component.html',
  styleUrls: ['./left-side-menu-admin-control.component.scss']
})
export class LeftSideMenuAdminControlComponent implements OnInit {
  constructor(public configService: ConfigService) {}

  ngOnInit(): void {}
  closeNav() {
    let element: HTMLElement = document.getElementsByClassName('closebtnIAG')[0] as HTMLElement;
    element.click();
  }
}
